import React from "react";
import { checkedInColors } from "./CheckedInStyles";

export function CheckedInMark({ dark, size }: { dark: boolean; size: number }): React.ReactElement {
    const color: string = dark ? checkedInColors.espresso : checkedInColors.butter;
    return (
        <svg width={size} height={size} viewBox="0 0 100 100" fill="none" aria-hidden="true">
            <circle cx="50" cy="53" r="27" stroke={color} strokeWidth="6" />
            <circle cx="50" cy="10" r="9" fill={color} />
            <circle cx="12" cy="35" r="9" fill={color} />
            <circle cx="88" cy="35" r="9" fill={color} />
            <circle cx="26" cy="88" r="9" fill={checkedInColors.tomato} />
            <circle cx="74" cy="88" r="9" fill={color} />
        </svg>
    );
}
